import { SectionHeading } from "../SectionHeading";
import { FeatureCard } from "../cards/FeatureCard";
import { motion } from "framer-motion";

export function FeatureSection({
    title,
    description,
    badge,
    features,
    ...rest
}) {
    return (
        <section
            className="bg-white dark:bg-base-900 pt-32 pb-24 relative overflow-hidden"
            {...rest}
        >
            <div className="absolute pointer-events-none z-0 -left-12 top-48 w-64 h-64 opacity-40">
                <img
                    src="/pattern-features.svg"
                    alt=""
                    className="w-full h-full"
                    onError={(e) => (e.target.style.display = "none")}
                />
            </div>
            <div className="absolute pointer-events-none z-0 -right-12 bottom-12 w-64 h-64 opacity-40">
                <img
                    src="/pattern-features.svg"
                    alt=""
                    className="w-full h-full"
                    onError={(e) => (e.target.style.display = "none")}
                />
            </div>

            <div className="container max-w-6xl px-4 sm:px-6 lg:px-8 mx-auto relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <SectionHeading
                        align="center"
                        title={title}
                        description={description}
                        badge={badge}
                    />
                </motion.div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 mt-12 max-w-4xl mx-auto">
                    {features.map((feature, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 40, scale: 0.97 }}
                            whileInView={{ opacity: 1, y: 0, scale: 1 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{
                                duration: 0.5,
                                delay: index * 0.12,
                                ease: [0.25, 0.46, 0.45, 0.94],
                            }}
                        >
                            <FeatureCard {...feature} />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
